/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinalizeUsageBasedInvoices200ResponseInvoicesInner
 */
export interface FinalizeUsageBasedInvoices200ResponseInvoicesInner {
    /**
     * 
     */
    spName?: string;
    /**
     * 
     */
    invoiceId?: string;
    /**
     * 
     */
    invoiceNumber?: string;
}

/**
 * Check if a given object implements the FinalizeUsageBasedInvoices200ResponseInvoicesInner interface.
 */
export function instanceOfFinalizeUsageBasedInvoices200ResponseInvoicesInner(value: object): value is FinalizeUsageBasedInvoices200ResponseInvoicesInner {
    return true;
}

export function FinalizeUsageBasedInvoices200ResponseInvoicesInnerFromJSON(json: any): FinalizeUsageBasedInvoices200ResponseInvoicesInner {
    return FinalizeUsageBasedInvoices200ResponseInvoicesInnerFromJSONTyped(json, false);
}

export function FinalizeUsageBasedInvoices200ResponseInvoicesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeUsageBasedInvoices200ResponseInvoicesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'spName': json['spName'] == null ? undefined : json['spName'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
        'invoiceNumber': json['invoiceNumber'] == null ? undefined : json['invoiceNumber'],
    };
}

export function FinalizeUsageBasedInvoices200ResponseInvoicesInnerToJSON(json: any): FinalizeUsageBasedInvoices200ResponseInvoicesInner {
    return FinalizeUsageBasedInvoices200ResponseInvoicesInnerToJSONTyped(json, false);
}

export function FinalizeUsageBasedInvoices200ResponseInvoicesInnerToJSONTyped(value?: FinalizeUsageBasedInvoices200ResponseInvoicesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spName': value['spName'],
        'invoiceId': value['invoiceId'],
        'invoiceNumber': value['invoiceNumber'],
    };
}

